export default "__VITE_ASSET__CXZTx8$X__"